import moment from 'moment';

const DATE_FORMAT = {
  ko: 'YYYY-MM-DD',
  en: 'MM-DD-YYYY'
};

const TIME_FORMAT = 'HH:mm';
const FULL_TIME_FORMAT = 'HH:mm:ss';

export function useDateTimeFormat() {
  const userLanguage = window.localStorage.getItem('language');
  const dateFormat = DATE_FORMAT[userLanguage] ?? DATE_FORMAT.ko;

  const formatDate = (val, fm = dateFormat) => moment(val).format(fm);

  const formatDateTime = (val, fm = TIME_FORMAT) => moment(val).format(`${dateFormat} ${fm}`);

  const fullTimeFormat = (val) => formatDateTime(val, FULL_TIME_FORMAT);

  return { dateFormat, FULL_TIME_FORMAT, formatDateTime, formatDate, fullTimeFormat };
}
